export default __webpack_public_path__ + "static/media/vip-12.d95e4fbe.gif";